// Goods Product.js

import React, { Component } from 'react';
import { Button, Form, Container, Row, Col, ButtonToolbar, Overlay, Popover } from 'react-bootstrap';
import Config from '../Config';
import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';
import GoodsProductQRList from './GoodsProductQRList';

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import Column from 'react-virtualized/dist/commonjs/Table/Column';
import Table from 'react-virtualized/dist/commonjs/Table';
import styles from './Table.css';

const ProductLocals = ["Eng", "Kor", "Jpn", "Chn", "Esp", "Fra"];

class Content extends Component {
    static defaultProps = {
        item: null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.state = {
            qrlistvisible: false,
            item: this.props.item,
            enable: false,
            images: [],
        };
        this.locals = ProductLocals;
        this.S3timer = null;
    }

    componentWillReceiveProps(nextProps) {
        console.log("componentWillReceiveProps: " + JSON.stringify(nextProps));
        this.setState({ item: nextProps.item, enable: nextProps.enable });
    }

    handleReset(event) {
        this.setState({
            item: {
                PCODE: '0000', TITLE: '', PRODUCTION: '', ARTIST: '' , EXPIRES : '0'
            }
            , enable: true
        });

        event.preventDefault();
    }

    handleChange(event) {
        var item = this.state.item;
        item.TITLE = event.target.value;
        this.setState({ item: item });
    }

    handleQRList() {
        this.setState({ qrlistvisible: true });
    }

    handleCloseQRList() {
        this.setState({ qrlistvisible: false });
    }

    handleChangePCODE(event) {
        var item = this.state.item;
        item.PCODE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeTITLE(event) {
        var item = this.state.item;
        item.TITLE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeARTIST(event) {
        var item = this.state.item;
        item.ARTIST = event.target.value;
        this.setState({ item: item });
    }

    handleChangeEXPIRES(event) {
        var item = this.state.item;
        item.EXPIRES = event.target.value;
        this.setState({ item: item });
    }

    handleChangePRODUCTION(event) {
        var item = this.state.item;
        item.PRODUCTION = event.target.value;
        this.setState({ item: item });
    }

    handleSubmit(event) {

        var result = confirm("저장 하시겠습니까?");
        if (result) {
            console.log('RRR', this.state.item)
            Config.fetchData('insGoodsProduct', {
                PCODE: this.state.item.PCODE,
                TITLE: this.state.item.TITLE,
                PRODUCTION: this.state.item.PRODUCTION,
                ARTIST: this.state.item.ARTIST,
                EXPIRES: this.state.item.EXPIRES
            }, (result, count) => {
                console.log('insproduct=', count);
                this.setState({ sendcount: count })
            }, true);
        }
        event.preventDefault();
    }

    handleRemove(event) {

        Config.fetchData('delproduct', {
            ID: this.state.item.ID,
            COUNTRY_CODE: this.state.item.COUNTRY_CODE,
            LANGUAGE_CODE: this.state.item.LANGUAGE_CODE
        }, (result, count) => {
            console.log('delproduct=', count);
            this.setState({ sendcount: count })

        }, true);

        event.preventDefault();
    }

    render() {
        return (
            <div className="box" >
                <div className="row" style={{ margin: 20 }}>
                    <Button variant="primary" onClick={this.handleSubmit.bind(this)}>저장</Button>
                    <Button variant="primary" onClick={this.handleQRList.bind(this)}>QR정보</Button>
                    {/* <Button variant="primary" onClick={this.handleRemove}>삭제</Button> */}
                </div>
                <div className="row" >
                    <Form>
                        {this.state.enable && <div style={{ margin: 20 }}>
                            <div className="col-md-6">
                                <Form.Row>
                                    <Form.Group as={Col} controlId="exampleForm.ControlInput1">
                                        <Form.Label>상품코드</Form.Label>
                                        <Form.Control type="title" placeholder="코드를 입력하세요." value={this.state.item.PCODE} onChange={this.handleChangePCODE.bind(this)} />
                                    </Form.Group>
                                </Form.Row>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>제목</Form.Label>
                                    <Form.Control type="title" placeholder="내용을 입력하세요." value={this.state.item.TITLE} onChange={this.handleChangeTITLE.bind(this)} />
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>프로덕션</Form.Label>
                                    <Form.Control type="title" placeholder="내용을 입력하세요." value={this.state.item.PRODUCTION} onChange={this.handleChangePRODUCTION.bind(this)} />
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>아티스트</Form.Label>
                                    <Form.Control type="title" placeholder="내용을 입력하세요." value={this.state.item.ARTIST} onChange={this.handleChangeARTIST.bind(this)} />
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>Expires(0: none, 5: 5mins)</Form.Label>
                                    <Form.Control type="title" placeholder="0" value={this.state.item.EXPIRES} onChange={this.handleChangeEXPIRES.bind(this)} />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                
                            </div>
                        </div>
                        }
                    </Form>
                </div>
                <div className="row">
                    <Modal visible={this.state.qrlistvisible} width="90%" effect="fadeInUp" onClickAway={this.handleCloseQRList.bind(this)}>
                        <div style={{ margin: 20 }}>
                            <table>
                                <tr>
                                    <td>
                                        <div className="row" style={{ margin: 16 }}>
                                            <Button variant="primary" onClick={this.handleCloseQRList.bind(this)}>X</Button>
                                        </div>
                                    </td>
                                    <td>
                                        <h2>QR 정보 [{this.state.item.PCODE}]</h2>
                                    </td>
                                </tr>
                            </table>
                            <GoodsProductQRList item={this.state.item} images={this.state.images} />
                        </div>
                    </Modal>
                </div>
            </div>
        );
    }
};

export default class GoodsProduct extends Component {
    static defaultProps = {
        onreset: () => { },
    }
    constructor(props) {
        super(props);
        this.state = {
            sendcount: 0,
            rowlist: [],
            productvisible: false,
            item: { 
                PCODE: '0000', TITLE: '', PRODUCTION: '', ARTIST: ''
            }
        };
    }

    handleRowClick = (event) => {
        var item = event.rowData;
        console.log(item);
        var edititem = { ...item };
        edititem.TITLE = item.TITLE;
        edititem.CONTENT = item.CONTENT;
        this.setState({ item: edititem });
        this.setState({ productvisible: true });

        event.preventDefault();
    }

    componentDidMount() {
        Config.fetchData('getGoodsProductList', {
        }, (result, count) => {
            console.log('count=', count);
            this.setState({ rowlist: result })
        }, true);
    }

    handleReset(event) {
        this.setState({
            item: {
                PCODE: '0000', TITLE: '', PRODUCTION: '', ARTIST: ''
            }
        })
    }

    handleNew() {
        this.handleReset(null);
        this.setState({ productvisible: true });
    }

    handleClose = () => {
        console.log('handleClose');
        this.componentDidMount();
        this.setState({ productvisible: false });
    }

    handleScroll(scrollData) {
        console.log(scrollData);
    }

    _noRowsRenderer() {
        return <div>No rows</div>;
    }

    _onScrollToRowChange(event) {
        const { rowCount } = this.state;
        let scrollToIndex = Math.min(
            rowCount - 1,
            parseInt(event.target.value, 10),
        );

        if (isNaN(scrollToIndex)) {
            scrollToIndex = undefined;
        }

        this.setState({ scrollToIndex });
    }

    _rowClassName({ index }) {
        if (index < 0) {
            return "headerRow";
        } else {
            return index % 2 === 0 ? "evenRow" : "oddRow";
        }
    }

    render() {
        let scrollbarStyles = { borderRadius: 5 };
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <table>
                                        <tr>
                                            <td>
                                                <h3 className="box-title">Goods 상품 등록</h3>
                                            </td>
                                            <td>
                                                <div className="row" style={{ margin: 16 }}>
                                                    <Button variant="primary" onClick={this.handleNew.bind(this)}>신규</Button>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div className="box-body" style={{ margin: 20 }}>
                                    <div className="row" >
                                        <AutoSizer disableHeight>
                                            {({ width }) => (
                                                <Table
                                                    ref="Table"
                                                    headerClassName={'headerColumn'}
                                                    onRowClick={this.handleRowClick}
                                                    headerHeight={30}
                                                    height={800}
                                                    noRowsRenderer={this._noRowsRenderer}
                                                    overscanRowCount={10}
                                                    rowClassName={this._rowClassName}
                                                    rowHeight={40}
                                                    rowGetter={({ index }) => this.state.rowlist[index]}
                                                    rowCount={this.state.rowlist.length}
                                                    scrollToIndex={this.state.scrollToIndex}
                                                    width={width}>
                                                    <Column
                                                        width={70}
                                                        disableSort
                                                        label="코드"
                                                        dataKey="PCODE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        style={{ minWidth: 40 }}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="제목"
                                                        dataKey="TITLE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={90}
                                                        disableSort
                                                        label="프로덕션"
                                                        dataKey="PRODUCTION"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="아티스트"
                                                        dataKey="ARTIST"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={150}
                                                        disableSort
                                                        label="EXPIRES"
                                                        dataKey="EXPIRES"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />                                                    
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="등록일"
                                                        dataKey="REGDATE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                </Table>
                                            )}
                                        </AutoSizer>
                                    </div>
                                    <div className="row">
                                        <Modal visible={this.state.productvisible} width="80%" effect="fadeInUp" onreset={() => { this.componentDidMount() }} onClickAway={() => this.handleClose()}>
                                            <div style={{ margin: 20 }}>
                                                <table>
                                                    <tr>
                                                        <td>
                                                            <div className="row" style={{ margin: 16 }}>
                                                                <Button variant="primary" onClick={this.handleClose.bind(this)}>X</Button>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <h2>상품내용</h2>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <Content item={this.state.item} enable={this.state.productvisible} onreset={() => { this.componentDidMount() }} />
                                            </div>
                                        </Modal>
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-6">
                                            <div className="description-block border-right">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/DigitalGoods/GoodsProduct.js